var React = require('react');

function Activity (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Heart Beat"),React.createElement("polyline",{"points":"22 12 18 12 15 21 9 3 6 12 2 12","key":1})]);
}

Activity.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-activity"};

module.exports = Activity;

Activity.default = Activity;
